import clsx from 'clsx';
import styles from './AccountSkeletons.module.css';

const SKELETON_KEYS = ['first', 'second', 'third'] as const;

export const TripCardSkeletons = ({ as: Tag = 'div' }: { as?: 'div' | 'li' }) => (
  <>
    {SKELETON_KEYS.map((key) => (
      <Tag key={key} className={clsx(styles.bar, styles.tripCard)} aria-hidden="true" />
    ))}
  </>
);

export const SettingsSkeleton = () => (
  <section className={styles.settings} aria-busy="true" aria-label="Loading account settings">
    <div className={clsx(styles.bar, styles.settingsIntro)} />
    <div className={clsx(styles.bar, styles.settingsButton)} />
    <div className={styles.settingsGroup}>
      <div className={clsx(styles.bar, styles.settingsLabel)} />
      <div className={clsx(styles.bar, styles.settingsField)} />
      <div className={clsx(styles.bar, styles.settingsField)} />
    </div>
    <div className={styles.settingsGroup}>
      <div className={clsx(styles.bar, styles.settingsLabel)} />
      <div className={clsx(styles.bar, styles.settingsField)} />
    </div>
  </section>
);
